/**
 * Created by sy on 2018/9/14.
 */
import * as types from "../mutations-type";
import fetch from "../../api/fetch";

const state = {
  getArticle: {
    id: "",
    details: "",
  },
};

const actions = {
  getArticleDetail({ commit }) {
    let url = "index.php/mobile/learn-column/list";
    let params = {
      company_id: localStorage.getItem("_user_data_company_id"),
      sso_token: localStorage.getItem("_user_data_sso_token"),
      sys_id: localStorage.getItem("_sys_id"),
      language: localStorage.getItem("_user_data_language"),
      size: 2,
      user_id: localStorage.getItem("_user_data_id"),
      type: "learn_column_document",
    };
    fetch.post(url, params).then((res) => {
      // console.log(res);
      commit(types.ARTICLE.DETAILS, res);
    });
  },
};

/*
const getters = {
  getArticle:state => state.getArticle
}
*/

const mutations = {
  [types.ARTICLE.DETAILS](state, payload) {
    state.getArticle.details = payload.data.result.data;
  },
};

export default {
  state,
  actions,
  // getters,
  mutations,
};
